import styled, { css } from 'styled-components';

import { IconExternalLink } from '@xing-com/icons';
import { minA11yTargetSize } from '@xing-com/layout-tokens';
import { Link as RouterLinkComponent } from '@xing-com/link';
import {
  scale010,
  scale100,
  spaceXXS,
  xdlColorFocusRing,
  xdlColorLink,
  xdlColorLinkHover,
  xdlColorLinkVisited,
} from '@xing-com/tokens';

// *** Base ***
const baseHyperlink = css`
  color: ${xdlColorLink};
  font-size: inherit;
  text-decoration-line: underline;
  text-decoration-skip-ink: none;
  text-decoration-style: solid;
  text-decoration-thickness: 8%;
  text-underline-offset: 20%;
  text-underline-position: from-font;
  position: relative;

  &::before {
    block-size: 100%;
    content: '';
    inline-size: 100%;
    inset-block-start: 50%;
    inset-inline-start: 50%;
    min-height: ${minA11yTargetSize};
    min-width: ${minA11yTargetSize};
    position: absolute;
    transform: translate(-50%, -50%);
  }

  &:hover {
    text-decoration-thickness: 13%;
  }

  &:hover,
  &:focus {
    color: ${xdlColorLinkHover};
  }

  &:visited {
    color: ${xdlColorLinkVisited};
  }
  &:focus {
    outline: ${scale010} solid ${xdlColorFocusRing};
    outline-offset: ${spaceXXS};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline: ${scale010} solid ${xdlColorFocusRing};
    outline-offset: ${spaceXXS};
    text-decoration-thickness: 13%;
  }
`;

// *** Components ***
export const Link = styled.a`
  ${baseHyperlink};
`;

export const RouterLink = styled(RouterLinkComponent)`
  ${baseHyperlink};
`;

export const ExternalIcon = styled(IconExternalLink)`
  bottom: -3px;
  margin-left: ${spaceXXS};
  position: absolute;
`;

export const IconContainer = styled.span`
  display: inline-block;
  position: relative;
  width: ${scale100};
`;
